import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {HttpGetProjectSocialWelfareConditionsResponse} from '../../http/projects.http'
import {
    activityAutonomyToLabel,
    applicantToLabel,
    mobilityAutonomyToLabel,
    networkSupportToLabel,
    parentalResponsibilityToLabel
} from '../../utils'
import {Divider} from '@/components/ui/divider/Divider'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

interface SocialWelfareConditionsCardViewProps {
    socialWelfareConditions: HttpGetProjectSocialWelfareConditionsResponse
    isEvolutionaryAge?: boolean
}
export const SocialWelfareConditionsCardView = ({
    socialWelfareConditions,
    isEvolutionaryAge
}: SocialWelfareConditionsCardViewProps) => {
    const {t} = useTranslation()

    return (
        <Grid columns={3} columnGap={3} rowGap={2} fullWidth>
            {isEvolutionaryAge && (
                <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                    <DetailsField fullWidth>
                        <Text palette="neutral" shade="500" size="textSm">
                            {t('projects:parental_responsibility')}
                        </Text>
                        <Text palette="neutral" shade="950" size="textSm" weight="500">
                            {socialWelfareConditions.parentalResponsibility &&
                                t(parentalResponsibilityToLabel[socialWelfareConditions.parentalResponsibility])}
                        </Text>
                    </DetailsField>
                    <Divider direction="horizontal" />
                </Flexbox>
            )}

            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Flexbox direction="column" gap={2}>
                        <Text palette="neutral" shade="500" size="textSm">
                            {t('projects:applicant')}
                        </Text>
                        <Text palette="neutral" shade="950" size="textSm" weight="500">
                            {t(applicantToLabel[socialWelfareConditions.applicant])}
                        </Text>
                    </Flexbox>
                </DetailsField>
                <Divider direction="horizontal" />
            </Flexbox>

            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:ssn_cost_percentage')}
                    </Text>
                    <Text palette="neutral" shade="950" size="textSm" weight="500">
                        {`${socialWelfareConditions.percentagePaid}%`}
                    </Text>
                </DetailsField>
                <Divider direction="horizontal" />
            </Flexbox>

            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:shared_care_planning')}
                    </Text>
                    <Text palette="neutral" shade="950" size="textSm" weight="500">
                        {socialWelfareConditions?.sharedCarePlanning ? t('commons:yes') : t('commons:no')}
                    </Text>
                </DetailsField>
                <Divider direction="horizontal" />
            </Flexbox>

            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:social_rehabilitation_treatments')}
                    </Text>
                    <Text palette="neutral" shade="950" size="textSm" weight="500">
                        {socialWelfareConditions?.socialRehabilitationTreatments ? t('commons:yes') : t('commons:no')}
                    </Text>
                </DetailsField>
                <Divider direction="horizontal" />
            </Flexbox>

            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:formal_or_informal_networks_support')}
                    </Text>
                    <Text palette="neutral" shade="950" size="textSm" weight="500">
                        {socialWelfareConditions.networkSupport
                            ? t(networkSupportToLabel[socialWelfareConditions.networkSupport])
                            : '-'}
                    </Text>
                </DetailsField>

                <Divider direction="horizontal" />
            </Flexbox>

            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:caregiver')}
                    </Text>
                    <Text palette="neutral" shade="950" size="textSm" weight="500">
                        {socialWelfareConditions?.caregiver ? t('commons:yes') : t('commons:no')}
                    </Text>
                </DetailsField>

                <Divider direction="horizontal" />
            </Flexbox>

            <DetailsField fullWidth justify="space-between">
                <Text palette="neutral" shade="500" size="textSm">
                    {t('projects:daily_activities_autonomy_level')}
                </Text>
                <Text palette="neutral" shade="950" size="textSm" weight="500">
                    {socialWelfareConditions.activityAutonomy
                        ? t(activityAutonomyToLabel[socialWelfareConditions.activityAutonomy])
                        : '-'}
                </Text>
            </DetailsField>

            <DetailsField fullWidth>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('projects:mobility_autonomy_level')}
                </Text>
                <Text palette="neutral" shade="950" size="textSm" weight="500">
                    {socialWelfareConditions.mobilityAutonomy
                        ? t(mobilityAutonomyToLabel[socialWelfareConditions.mobilityAutonomy])
                        : '-'}
                </Text>
            </DetailsField>
        </Grid>
    )
}
